import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import {
  ListDisplay,
  ContentDisplay,
  BaseText,
  ProgressStep,
  HeadingDisplay,
  InitialAvatarIcon
} from '@warrenbrasil/nebraska-web';
import { IOrderReceipt } from '@/modules/wealth/services/wealth-orders/types';
import { IStep } from '../../types';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvestmentSteps',
  props: {
    orderData: null,
    progress: null
  },
  setup(__props: any) {

const props = __props as {
  orderData: IOrderReceipt | null;
  progress: IStep[];
}



const isCanceled = computed(() => {
  return props.orderData?.status?.label === 'Cancelado';
});

const isSchedule = computed(() => {
  return props.orderData?.status?.label === 'Agendado';
});

const footerType = computed(() => {
  return isCanceled.value ? 'caption' : 'button';
});

const footerLabel = computed(() => {
  return isCanceled.value
    ? props.orderData?.description
    : 'Detalhes do Produto';
});

return { __sfc: true,props, isCanceled, isSchedule, footerType, footerLabel, ListDisplay, ContentDisplay, BaseText, ProgressStep, HeadingDisplay, InitialAvatarIcon }
}

})